export default "__VITE_ASSET__9cf4dd44__"